import { LucideIconData } from 'lucide-angular';

export const PoolCaC14: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['circle', { cx: '12', cy: '9', r: '3' }],
  ['path', { d: 'M9.5 12 L8 17 L12 15 L16 17 L14.5 12' }],
];
